export enum BreakpointsId {
  ExtraSmall = 'xs',
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
  ExtraLarge = 'exLg',
}

const BREAKPOINTS: Record<BreakpointsId, number> = {
  [BreakpointsId.ExtraSmall]: 375,
  [BreakpointsId.Small]: 575,
  [BreakpointsId.Medium]: 768,
  [BreakpointsId.Large]: 992,
  [BreakpointsId.ExtraLarge]: 1200,
}

export default Object.fromEntries(
  Object.entries(BREAKPOINTS).map(([key, value]) => [key, `${value}px`]),
)
